var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('label', {
    staticClass: "inp-text inp--label-prop",
    class: _vm.special
  }, [_c('input-subtle', {
    staticStyle: {
      "opacity": ".7"
    },
    attrs: {
      "placeholder": "property..."
    },
    on: {
      "blur": _vm.submit,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }
    },
    model: {
      value: (_vm.prop),
      callback: function($$v) {
        _vm.prop = $$v
      },
      expression: "prop"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "placeholder": _vm.prop && 'value...'
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "blur": _vm.submit,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655412cf","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropAdd.vue
// module id = 75
// module chunks = 1